import axios from "axios"
import {
  CATALOGS_MOD_WAREHOUSE,
  CATALOGS_ADD_WAREHOUSE_MODE,
  CATALOGS_DELETE_WAREHOUSE_MODE,
  CATALOGS_EDIT_WAREHOUSE_MODE,
  CATALOGS_WAREHOUSE_SELECTED,
  CATALOGS_CREATE_WAREHOUSE,
  CATALOGS_DELETE_WAREHOUSE,
  CATALOGS_GET_WAREHOUSES,
  CATALOGS_GET_LICENSE,
  CATALOGS_RESET_WAREHOUSE_SELECTED,
  CATALOGS_SET_WAREHOUSE_FILTERS
} from "redux/reducers/warehousesCatalog/warehousesCatalogReducer"
import { setSnackbar, startRequestComp, stopRequestComp } from "redux/actions/search/searchActions";
import { api_delete, PROYECT } from "services/api";
import { LOADING_ACTIONS } from "redux/reducers/warehousesCatalog/warehousesTypes"; 

const mainUrl = `${process.env.REACT_APP_URL}${PROYECT}`;

export const setWarehousesCatalogFilters = (key = "", data) => ({
  type: CATALOGS_SET_WAREHOUSE_FILTERS,
  payload: { data, key }
})

export const getCRE_Licenses = (token) => {
  const url = `${process.env.REACT_APP_URL}/crm/stations/cre_licenses`
  const headers = { headers: { Authorization: token } }
  return async (dispatch) => {
    dispatch(startRequestComp('loadingWarehouses'));
    try {
      const resp = await axios.get(url, headers)
      dispatch({
        type: CATALOGS_GET_LICENSE,
        payload: resp.data
      })
    } catch (error) {
      dispatch(setSnackbar(error));
    } finally {
      dispatch(stopRequestComp('loadingWarehouses'));
    }
  }
}

export const getWarehouses = (token) => {
  const url = `${process.env.REACT_APP_URL}/crm/stations/storages`
  const headers = { headers: { Authorization: token } }
  return async (dispatch) => {
    dispatch(startRequestComp('loadingWarehouses'));
    try {
      const resp = await axios.get(url, headers)
      dispatch({
        type: CATALOGS_GET_WAREHOUSES,
        payload: resp.data
      })
    } catch (error) {
      dispatch(setSnackbar(error));
    } finally {
      dispatch(stopRequestComp('loadingWarehouses'));
    }
  }
}

export const warehouseSelected = (id) => {
  return {
    type: CATALOGS_WAREHOUSE_SELECTED,
    payload: id
  }
}

export const addWarehouseMode = () => {
  return {
    type: CATALOGS_ADD_WAREHOUSE_MODE,
  }
}

export const editWarehouseMode = () => {
  return {
    type: CATALOGS_EDIT_WAREHOUSE_MODE,
  }
}

export const deleteWarehouseMode = () => {
  return {
    type: CATALOGS_DELETE_WAREHOUSE_MODE,
  }
}

export const resetWarehouseSelected = () => {
  return {
    type: CATALOGS_RESET_WAREHOUSE_SELECTED
  }
}

export const createNewWarehouse = (form, token) => {
  const url = `${process.env.REACT_APP_URL}/crm/stations/storages`
  const headers = { headers: { Authorization: token } }
  return async (dispatch) => {
    dispatch(startRequestComp('loadingWarehouses'));
    try {
      const resp = await axios.post(url, form, headers)
      dispatch({
        type: CATALOGS_CREATE_WAREHOUSE,
        payload: resp.data
      })
      dispatch(setSnackbar("Creado con éxito", "success"));
    } catch (error) {
      dispatch(setSnackbar(error));
    } finally {
      dispatch(stopRequestComp('loadingWarehouses'));
    }
  }
}

export const editWarehouse = (id, form, token) => {
  const url = `${process.env.REACT_APP_URL}/crm/stations/storages/${id}`
  const headers = { headers: { Authorization: token } }
  return async (dispatch) => {
    dispatch(startRequestComp('loadingWarehouses'));
    try {
      const resp = await axios.put(url, form, headers)
      dispatch({
        type: CATALOGS_MOD_WAREHOUSE,
        payload: resp.data
      })
      dispatch(setSnackbar("Actualizado con éxito", "success"));
    } catch (error) {
      dispatch(setSnackbar(error));
    } finally {
      dispatch(stopRequestComp('loadingWarehouses'));
    }
  }
}

export const deleteWarehouse = (id, action = null) => async (dispatch) => {
  const url = `${mainUrl}/stations/storages/${id}`;
  dispatch(startRequestComp(LOADING_ACTIONS.DELETE));
  try {
    const resp = await api_delete(url);
    dispatch({
      type: CATALOGS_DELETE_WAREHOUSE,
      payload: resp.id,
    });
    dispatch(setSnackbar("Almacén eliminado con éxito", "success"));
    action && action();
  } catch (error) {
    dispatch(setSnackbar(error));
  } finally {
    dispatch(stopRequestComp(LOADING_ACTIONS.DELETE));
  }
};
